import React, { SVGProps } from "react";
export default function SupUserAnon011(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.8997 12.676H14.5162L8.80806 3.1972M11.8997 12.676L9.76053 9.00056M11.8997 12.676H7.84654M8.80806 3.1972H11.1919L18 14.9829M8.80806 3.1972L2 14.9829L3.03235 16.8028M18 14.9829L16.7097 16.8028H3.03235M18 14.9829H6.64523L7.84654 12.676M3.03235 16.8028L8.70973 7.19507L9.76053 9.00056M9.76053 9.00056L7.84654 12.676"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
